// extracted by mini-css-extract-plugin
export default {"message":"styles__message--SdLi3","json-value":"styles__json-value--0Pylu","json-node-container":"styles__json-node-container--FKYsA"};